import React from "react";
import {
  Box,
  Typography,
  Chip,
  Grid,
  IconButton,
  Card,
  CardMedia,
  CardContent,
  Button,
  Container,
  AppBar,
  Toolbar
} from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import FavoriteIcon from '@mui/icons-material/Favorite';
import ShareIcon from '@mui/icons-material/Share';

export default function GalleryDetailPage({ image, galleryData, onBack }) {
  if (!image) return null;
  
  const relatedImages = galleryData.filter(
    item => item.id !== image.id && item.location === image.location
  ).slice(0, 3);

  return (
    <Box sx={{ bgcolor: 'background.default', minHeight: '100vh' }}>
      {/* <AppBar position="sticky" color="default" elevation={1}>
        <Toolbar>
          <IconButton
            edge="start"
            aria-label="back"
            onClick={onBack}
          >
            <ArrowBackIosNewIcon />
          </IconButton>
          <Typography variant="h6" sx={{ flexGrow: 1 }}>
            {image.title}
          </Typography>
          <Button color="inherit">Share</Button>
        </Toolbar>
      </AppBar> */}
      
      <Container maxWidth="lg" sx={{ py: 4 }}>
        <Grid container spacing={4}>
          <Grid item xs={12} md={8}>
            <Card sx={{ borderRadius: 3, overflow: "hidden", boxShadow: 3 }}>
              <CardMedia
                component="img"
                image={image.image}
                alt={image.title}
                sx={{ width: "100%", maxHeight: "70vh", objectFit: "cover" }}
              />
            </Card>
            
            {/* Action buttons */}
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 3 }}>
              <Box>
                <Button startIcon={<FavoriteIcon />} color="error">
                  {image.likes} Likes
                </Button>
                {/* <Button startIcon={<ShareIcon />} sx={{ ml: 2 }}>
                  Share
                </Button> */}
              </Box>
              <Typography variant="body2" color="text.secondary">
                {image.views} views
              </Typography>
            </Box>
          </Grid>
          
          <Grid item xs={12} md={4}>
            <Typography variant="h3" gutterBottom fontWeight="bold">
              {image.title}
            </Typography>
            
            <Box sx={{ display: "flex", flexWrap: 'wrap', gap: 1, mb: 3 }}>
              <Chip label={image.location} color="primary" />
              <Chip label={image.category} variant="outlined" />
              <Chip label={image.date} variant="outlined" />
            </Box>
            
            <Typography variant="body1" paragraph sx={{ lineHeight: 1.8, fontSize: '1.1rem' }}>
              {image.description}
            </Typography>
            
            <Typography variant="body2" color="text.secondary" sx={{ mt: 4 }}>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
            </Typography>
          </Grid>
        </Grid>
        
        {/* Related Images section */}
        {relatedImages.length > 0 && (
          <Box sx={{ mt: 8 }}>
            <Typography variant="h4" gutterBottom sx={{ mb: 4, fontWeight: 'bold' }}>
              Related Images
            </Typography>
            
            <Grid container spacing={3}>
              {relatedImages.map(item => (
                <Grid item xs={12} sm={6} md={4} key={item.id}>
                  <Card 
                    sx={{ 
                      borderRadius: 3, 
                      overflow: "hidden", 
                      cursor: "pointer",
                      transition: "transform 0.3s ease, box-shadow 0.3s ease",
                      "&:hover": {
                        transform: "translateY(-8px)",
                        boxShadow: "0 15px 35px rgba(0,0,0,0.2)",
                      }
                    }}
                  >
                    <CardMedia
                      component="img"
                      height="220"
                      image={item.image}
                      alt={item.title}
                      sx={{ objectFit: "cover" }}
                    />
                    <CardContent>
                      <Typography variant="h6" gutterBottom noWrap>
                        {item.title}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        {item.location} • {item.date}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </Box>
        )}
      </Container>
    </Box>
  );
}